import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import paths from '../../paths.json';

import { useAuthentication } from './index';

const useRedirect = (param = 'redirect'): (() => void) => {
  const location = useLocation();
  const history = useHistory();
  const { accessToken } = useAuthentication();

  const path = new URLSearchParams(location.search).get(param) || paths.home;

  return useCallback(() => {
    if (/^https?:\/\//i.test(path)) {
      if (accessToken) {
        return window.location.replace(`${path}?accessToken=${accessToken}`);
      }

      return window.location.replace(`${path}`);
    }

    return history.replace(path);
  }, [accessToken, history, path]);
};

export default useRedirect;
